import { render, staticRenderFns } from "./RatingSetEdit.vue?vue&type=template&id=03981a18"
import script from "./RatingSetEdit.vue?vue&type=script&lang=js"
export * from "./RatingSetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports